import React from 'react';
import { Link } from 'react-router-dom';
import { useUserSystems } from '@/hooks/useUserSystems';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { DefaultSystemModal } from '@/components/DefaultSystemModal';
import { ChevronDown, ExternalLink } from 'lucide-react';

interface UserSystemsMenuProps {
  trigger?: React.ReactNode;
}

export function UserSystemsMenu({ trigger }: UserSystemsMenuProps) {
  const { data: systems = [], isLoading } = useUserSystems();

  if (isLoading) {
    return null;
  }

  if (systems.length === 0) {
    return null;
  }

  // If only one system, show the system name directly
  const buttonText = systems.length === 1 ? systems[0].name : 'Sistemas';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        {trigger || (
          <Button variant="ghost" className="h-auto px-2">
            {buttonText}
            <ChevronDown className="ml-1 h-4 w-4" />
          </Button>
        )}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>Sistemas Disponíveis</DropdownMenuLabel>
        <DropdownMenuSeparator />
        
        {systems.map((system) => (
          <DropdownMenuItem key={system.id} asChild>
            <Link 
              to={system.app_base_path || '/no-access'} 
              className="flex items-center justify-between w-full"
            >
              <span>{system.name}</span>
              <ExternalLink className="h-3 w-3" />
            </Link>
          </DropdownMenuItem>
        ))}
        
        {systems.length > 1 && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem asChild>
              <DefaultSystemModal 
                trigger={
                  <Button variant="ghost" size="sm" className="w-full justify-start">
                    Configurar Sistema Padrão
                  </Button>
                }
              />
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}